import React from 'react';
export function Audience() {
  const audiences = ['Investors looking to buy a beauty business in Dubai', 'Entrepreneurs entering the UAE beauty market', 'Beauty professionals who want to open their own salon or clinic', 'International founders relocating to Dubai', 'Business owners who want a structured launch plan', 'Investors who want to check a business before purchasing'];
  return <section className="py-24 bg-charcoal text-cream" data-id="element-20">
      <div className="max-w-7xl mx-auto px-6" data-id="element-21">
        <div className="grid md:grid-cols-3 gap-12" data-id="element-22">
          <div className="md:col-span-1" data-id="element-23">
            <h2 className="text-sm font-sans font-semibold tracking-[0.2em] text-gold uppercase mb-4" data-id="element-24">
              Who We Serve
            </h2>
            <h3 className="text-4xl font-serif mb-6" data-id="element-25">
              Is This Service For You?
            </h3>
            <p className="text-cream-dark font-light leading-relaxed" data-id="element-26">
              We partner with driven individuals and organizations looking to
              make a confident entry into the lucrative Dubai beauty sector.
            </p>
          </div>

          <div className="md:col-span-2 grid sm:grid-cols-2 gap-x-8 gap-y-6" data-id="element-27">
            {audiences.map((audience, index) => <div key={index} className="border-t border-cream/20 pt-6" data-id="element-28">
                <span className="text-gold font-serif text-xl block mb-2" data-id="element-29">
                  0{index + 1}.
                </span>
                <p className="text-cream-dark font-light" data-id="element-30">{audience}</p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}